import { render, staticRenderFns } from "./AttentionRow.vue?vue&type=template&id=6c338aad&scoped=true"
import script from "./AttentionRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AttentionRow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AttentionRow.vue?vue&type=style&index=0&id=6c338aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c338aad",
  null
  
)

export default component.exports